module.exports = __webpack_public_path__ + "img/breviary3.836c9b17.jpg";